import styles from './Modal.module.css';

export type ModalProps = {
    children: React.ReactNode;
};

export function Modal({ children }: ModalProps) {
    return (
        <div className={styles.modal}>
            <div className={styles.modalContent}>{children}</div>
        </div>
    );
}
